// extracted by mini-css-extract-plugin
export default {"error":"contacts_error__Pil7-","message":"contacts_message__FnbIK","notmessage":"contacts_notmessage__Dd9g-"};